import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/almarai/400.css';
import '@fontsource/almarai/700.css';
import './src/styles/global.css';
import './src/styles/unreset.css';

// Restrict navigation to only home and thank-you pages
export const onRouteUpdate = ({ location, prevLocation, replace }) => {
  if (typeof window === 'undefined') return;
  const allowed = ['/', '/thank-you'];
  const path = location && location.pathname ? location.pathname : '/';
  if (!allowed.includes(path)) {
    // If coming from thank-you, send to home; otherwise keep to allowed pages
    replace('/');
  }
};

export const onClientEntry = () => {
  if (typeof window === 'undefined') return;
  const { pathname } = window.location;
  const allowed = ['/', '/thank-you'];
  if (!allowed.includes(pathname)) {
    window.location.replace('/');
  }
};
